import { pages } from "@routes/pages";

import { BinTypeItem } from "../BinTypeItem";
import { typesManagementPageFor } from "../typesManagementPageFor";

export default typesManagementPageFor(BinTypeItem, pages.binTypes);
